import pinyin from "pinyin";
let cache = {};
let pinyinEnabled = false;

/**
 * Convert the Chinese words into English Letters, and just return the first English letter of individual word
 * For Chinese character, return the lower case Pinyin string.
 * For English letter, just return the original letter
 * For example, if the text is '美国', the complete pinyin code is 'mei guo', Simplify it, we get 'mg'; If the text is 'mg', we still get 'mg'
 * @param {string} text - the text to be converted
 * @param {boolean} [noCache] - if true, then do not cache the translated value
 */
export function getPinyin(text: string, noCache: boolean = false): string {
	if (!text) {
		return text;
	}

	let result = cache[text];

	if (result === undefined) {
		result = pinyin(text, {
			group: false,
			segment: false,
			style: pinyin.STYLE_FIRST_LETTER,
		}).join("");

		if (!noCache) {
			cache[text] = result;
		}
	}

	return result;
}

/**
 * Enable use of pinyin in the system
 */
export function enablePinyin(): void {
	pinyinEnabled = true;
}

/**
 * Reset cache storing converted pinyin values
 */
export function clearPinyinCache(): void {
	cache = {};
}

/**
 * Determine if application should check for pinyin text
 */
export function isPinyinEnabled(): boolean {
	return pinyinEnabled;
}